package io.horion.cv.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.CoverLetterSectionStyle
import io.horion.cv.styles.CoverLetterStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.UBUNTU
import io.horion.cv.models.CoverLetterData
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.styles.ArrowImageStyle
import io.horion.cv.styles.ArrowWrapperStyle
import io.horion.cv.styles.DesktopCarouselContainerStyle
import io.horion.cv.styles.LetterCarouselWrapperStyle
import io.horion.cv.styles.LetterRowStyle
import io.horion.cv.styles.MobileCarouselContainerStyle
import io.horion.cv.styles.MotivationSectionStyle
import io.horion.cv.styles.MotivationSubtitleStyle
import io.horion.cv.styles.MotivationTitleStyle
import io.horion.cv.styles.ViewMoreButtonStylecss
import io.horion.cv.styles.ViewMoreLabelLongStyle
import io.horion.cv.styles.ViewMoreLabelShortStyle
import io.horion.cv.utils.Constants.POPPINS
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@OptIn(DelicateApi::class)
@Composable
fun MotivationLetterSection() {
    val letters = CoverLetterData.letters.values.toList()
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val sectionBg = if (isDark) Colors.DarkBG else Colors.White

    Column(
        modifier = MotivationSectionStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(sectionBg),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            "Joignez une lettre de motivation\n parfaite à votre CV",
            modifier = MotivationTitleStyle.toModifier()
                .fontFamily(POPPINS)
                .fontWeight(FontWeight.SemiBold)
                .color(Colors.DarkBlue)
                .styleModifier { property("text-align", "center") }
        )
        SpanText(
            "et augmentez vos chances\n d'obtenir le poste",
            modifier = MotivationSubtitleStyle.toModifier()
                .fontFamily(POPPINS)
                .fontWeight(FontWeight.SemiBold)
                .color(Colors.DarkBlue)
                .styleModifier { property("text-align", "center") }
        )


        Box(modifier = MobileCarouselContainerStyle.toModifier()) {
            LetterCarousel(letters = letters.take(4))
        }

        // Affichage Desktop (Grid/Row)
        Row(
            modifier = DesktopCarouselContainerStyle.toModifier()
                .then(LetterRowStyle.toModifier())
                .fillMaxWidth()
                .gap(30.px)
                .padding(leftRight = 60.px)
                .justifyContent(JustifyContent.Center)
        ) {
            letters.take(4).forEach { letter ->
                CoverLetterCard(letter = letter)
            }
        }

        ViewMoreButton(
            onClick = { ctx.router.navigateTo(Screen.Motivation.path) },
        )
    }
}

@Composable
fun CoverLetterCard(letter: String) {
    var isHovered by remember { mutableStateOf(false) }
    val ctx = rememberPageContext()
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val cardBorderColor = if (isDark) Colors.holder else Colors.GrayLight

    Box(
        modifier = Modifier
            .width(260.px)
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
            .cursor(Cursor.Pointer)
            .onClick { ctx.router.navigateTo("/info_letter_page") },
        contentAlignment = Alignment.Center
    ) {
        Image(
            src = letter,
            description = "lettre de motivation",
            modifier = CoverLetterStyle.toModifier()
                .width(260.px)
                .border(1.px, LineStyle.Solid, cardBorderColor)
                .styleModifier {
                    property("filter", if (isDark) "brightness(0.85)" else "none")
                    property("transition", "filter 300ms ease")
                }
        )

        if (isHovered) {
            Link(
                path = "/info_letter_page",
                modifier = Modifier.textDecorationLine(TextDecorationLine.None)
            ) {
                val hoverBtnBg = if (isDark) Colors.LighterBlue else Colors.Blue

                Box(
                    modifier = Modifier
                        .opacity(0.83)
                        .width(150.px)
                        .height(40.px)
                        .backgroundColor(hoverBtnBg)
                        .borderRadius(10.px),
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        "Utiliser ce modèle",
                        modifier = Modifier
                            .color(Colors.White)
                            .fontSize(15.px)
                            .fontFamily(UBUNTU)
                            .fontWeight(FontWeight.Medium)
                            .whiteSpace(WhiteSpace.NoWrap)
                    )
                }
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun LetterCarousel(letters: List<String>) {
    val pageCount = letters.size
    var page by remember { mutableStateOf(0) }
    var targetPage by remember { mutableStateOf(0) }
    var animating by remember { mutableStateOf(false) }
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val chevronBg = if (isDark) Colors.DarkBG else Colors.Blue
    val navBg     = if (isDark) Colors.DarkBG else Colors.GrayLight

    Column(
        modifier = LetterCarouselWrapperStyle.toModifier()
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .position(Position.Relative)
                .overflow(Overflow.Hidden),
            contentAlignment = Alignment.Center
        ) {
            if (page > 0) {
                Box(
                    modifier = Modifier
                        .size(28.px)
                        .borderRadius(40.px)
                        .cursor(Cursor.Pointer)
                        .backgroundColor(Colors.LighterBlue)
                        .position(Position.Absolute)
                        .left(30.px)
                        .styleModifier { property("z-index", "10")
                            property("transition", "background-color 300ms ease")
                        }
                        .onClick {
                            if (!animating) {
                                targetPage = page - 1
                                animating = true
                            }
                        },
                    contentAlignment = Alignment.Center
                ) {

                    FaChevronLeft(
                        modifier = Modifier
                            .fontSize(18.px)
                            .color(Colors.White)
                    )
                }
            }

            Box(
                modifier = Modifier
                    .width(100.percent)
                    .overflow(Overflow.Hidden)
            ) {
                Row(
                    modifier = Modifier
                        .width((pageCount * 100).percent)
                        .styleModifier {
                            property(
                                "transform",
                                "translateX(-${targetPage * (100.0 / pageCount)}%)"
                            )
                            property("transition", "transform 400ms ease")
                        }
                ) {
                    letters.forEach { src ->
                        Box(
                            modifier = Modifier
                                .width((100.0 / pageCount).percent)
                                .padding(leftRight = 60.px),
                            contentAlignment = Alignment.Center
                        ) {
                            CoverLetterCard(letter = src)
                        }
                    }
                }
            }

            if (page < pageCount - 1) {
                Box(
                    modifier = Modifier
                        .size(28.px)
                        .borderRadius(40.px)
                        .cursor(Cursor.Pointer)
                        .backgroundColor(Colors.LighterBlue)
                        .position(Position.Absolute)
                        .right(30.px)
                        .styleModifier { property("z-index", "10")
                            property("transition", "background-color 300ms ease")
                        }
                        .onClick {
                            if (!animating) {
                                targetPage = page + 1
                                animating = true
                            }
                        },
                    contentAlignment = Alignment.Center
                ) {
                    FaChevronRight(
                        modifier = Modifier.fontSize(18.px)
                            .color(Colors.White)
                    )
                }
            }
        }

        if (animating) {
            LaunchedEffect(targetPage) {
                delay(400)
                page = targetPage
                animating = false
            }
        }

        Box(
            modifier = Modifier
                .margin(top = 16.px)
                .padding(leftRight = 8.px, topBottom = 6.px)
                .borderRadius(50.px)
                .backgroundColor(navBg)
                .styleModifier { property("transition", "background-color 300ms ease") },
            contentAlignment = Alignment.Center
        ) {
            Row(
                modifier = Modifier.gap(8.px),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                repeat(pageCount) { index ->
                    val dotColor = when {
                        index == page -> Colors.LighterBlue
                        isDark -> Colors.gray
                        else -> Colors.LightGray
                    }

                    Box(
                        modifier = Modifier
                            .size(6.px)
                            .borderRadius(50.px)
                            .backgroundColor(dotColor)
                            .styleModifier { property("transition", "background-color 300ms ease") }
                            .cursor(Cursor.Pointer)
                            .onClick {
                                if (!animating && index != page) {
                                    targetPage = index
                                    animating = true
                                }
                            }
                    )
                }
            }
        }
    }
}

@Composable
fun ViewMoreButton(
    onClick: (SyntheticMouseEvent) -> Unit,
) {

    Button(
        onClick = onClick,
        modifier = CoverLetterSectionStyle.toModifier()
            .then(ViewMoreButtonStylecss.toModifier())
            .borderRadius(50.px)
            .fontFamily(UBUNTU)
            .fontWeight(FontWeight.Normal)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("gap", "0px")
                property("overflow", "hidden")
            }
    ) {
        SpanText("Voir les modèles", modifier = ViewMoreLabelShortStyle.toModifier())
        SpanText("Voir les modèles de lettre de motivation", modifier = ViewMoreLabelLongStyle.toModifier())

        Box(
            modifier = ArrowWrapperStyle.toModifier(),
            contentAlignment = Alignment.Center
        ) {
            FaArrowRight(modifier = ArrowImageStyle.toModifier())
        }
    }
}



